module.exports = "/_next/static/images/CreateHighlyPersonalizedExperiences@2x-8fc4e6ba3c35501efd9cb9d8efdc03b0.png";